import React from "react";
import PropTypes from "prop-types";
import moment from "moment";

import { getSmileySource } from "../../../../store/helpers/uiHelper";
import { getStressClassname } from "../../utils/reportsStandards";

import DonutChar from "../../../../components/DonutChart";

import "./CompareScores.scss";

const DATE_FORMAT = "MMM YYYY";
function CompareScores(props) {
  const { initialData, lastData, acronym } = props;
  return (
    <div className="compare-score">
      <div className="compare-score__item date-start">
        {moment(initialData.date).format(DATE_FORMAT)}
      </div>
      <div className="compare-score__item date-end">
        {moment(lastData.date).format(DATE_FORMAT)}
      </div>
      <div className="compare-score__item score-start">
        <DonutChar
          score={initialData.average}
          color={getStressClassname(initialData.average)}
        />
      </div>
      <div className="compare-score__item icon-start score-icon">
        <img width={36} src={getSmileySource(initialData.average)} alt="" />
      </div>
      <div className="compare-score__item score-end">
        <DonutChar
          score={lastData.average}
          color={getStressClassname(lastData.average)}
        />
      </div>
      <div className="compare-score__item icon-end score-icon">
        <img width={36} src={getSmileySource(lastData.average)} alt="" />
      </div>
      <div className="compare-score__item acronym">{acronym}</div>
    </div>
  );
}

CompareScores.propTypes = {
  initialData: PropTypes.exact({
    average: PropTypes.number,
    date: PropTypes.string,
  }),
  lastData: PropTypes.exact({
    average: PropTypes.number,
    date: PropTypes.string,
  }),
  acronym: PropTypes.string,
};

export default CompareScores;
